module.exports = __webpack_public_path__ + "img/p020.f43cea28.png";